<template>
  <a-col :span="24">
    <a-form-item
      name="qualities"
      label="Качества студентов"
      class="qualities_form_item"
      :help="errors.getError('qualities')"
      :validate-status="errors.getStatus('qualities')"
    >
      <c-input-qualities
        :items="qualities"
        :disabled="disabled"
        @update="updateQualities"
      />
    </a-form-item>
  </a-col>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import { useRoute } from 'vue-router';
  import ErrorsHandler from '@/components/form/errors-handler';
  import CInputQualities from '@/components/UI/CInputQualities.vue';

  const api = useApi();
  const route = useRoute();
  const emit = defineEmits(['saved']);

  defineProps({
    disabled: {
      type: Boolean,
      default: false,
    },
  });

  const qualities = ref([]);

  const errors = new ErrorsHandler({
    qualities: '',
  });

  onMounted(async () => {
    await getQualities();
  });

  const getQualities = async () => {
    try {
      const response = await api.quality.index(
        new URLSearchParams({
          briefcaseId: route.params.id,
        })
      );
      qualities.value = response.qualities.items;
    } catch (error) {
      console.error('error', error);
    }
  };

  const onFinish = async () => {
    try {
      await api.briefcase.saveQualities({
        briefcaseId: route.params.id,
        qualities: qualities.value,
      });

      await getQualities();
      emit('saved', true);
    } catch (error) {
      errors.handleApiErrors(error);
      emit('saved', false);
    }
  };

  const updateQualities = (qualityList) => {
    qualities.value = [...qualityList];
  };

  defineExpose({ onFinish });
</script>

<style lang="scss" scoped>
  @use '@/components/form/main-form.scss';

  .qualities_form_item {
    margin-bottom: 14px;
  }
</style>
